var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnlarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.017 8.01226L20.4341 7.979L17.0898 11.3565L18.9441 13.2108L22.3216 9.86647L22.2883 12.2506L24.9374 12.2836L25.0037 5.29688L18.017 5.36316L18.017 8.01226Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2883 18.3119L22.3216 20.7291L18.9441 17.3516L17.0898 19.2391L20.4341 22.5834H18.017V25.2324L25.0037 25.2655L24.9374 18.2787L22.2883 18.3119Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84788 11.9535L7.81486 9.53637L11.1924 12.9139L13.0466 11.0264L9.70214 7.68208H12.1195V5.03303L5.13281 5L5.19887 11.9867L7.84788 11.9535Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9867 22.5834H9.56954L12.9138 19.2391L11.0596 17.3516L7.68208 20.7291L7.71534 18.3119L5.06629 18.2787L5 25.2654L11.9867 25.2324L11.9867 22.5834Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnlarge);
export default __webpack_public_path__ + "static/media/Enlarge.a2ef28033936b4b84eeeeb17165abc1d.svg";
export { ForwardRef as ReactComponent };